<!-- 常用提示词弹窗 -->
<template>
  <transition appear name="fade-slide">
    <div v-if="dialogVisible" class="common-used">
      <!-- 头部 -->
      <div class="common-used__header">
        <div class="header__left">
          <i class="icon-ai-generate-2 t-iconfont" />
          <span class="font-bold header__left-text text-color-main text-normal-4">我的常用</span>
        </div>
        <i class="icon-close-large-line t-iconfont" @click="dialogVisible = false" />
      </div>
      <!-- 提示词列表 -->
      <ul v-loading="loading" class="common-used__list hide-scrollbar">
        <li v-for="item in promptList" :key="item.id" class="item" @click="handleSelect(item)">
          <div class="item__title">
            <img alt="AI生成图标" src="@/assets/chat-1-line.svg" />
            <span class="font-bold text-color-main text-normal-4">{{ item.name }}</span>
          </div>
          <p class="item__content text-color-auxiliary text-normal-5">{{ item.content }}</p>
        </li>
      </ul>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { getCustomPromptTemplateList } from '@/api'

const emits = defineEmits(['update:show', 'setPrompt'])
const props = defineProps({
  // 对话框显示状态
  show: {
    type: Boolean,
    default: false
  }
})

// 计算属性-本地对话框显示状态
const dialogVisible = computed({
  get: () => props.show,
  set: (val) => emits('update:show', val)
})

const loading = ref(false)

// 常用提示词列表
const promptList = ref([])

/**
 * 获取常用提示词列表
 */
const getTheCustomPromptTemplateList = async () => {
  loading.value = true
  try {
    const { result } = await getCustomPromptTemplateList({
      page: 1,
      pageSize: 30
    })
    promptList.value = result?.dataList || []
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}
/**
 * 处理选择常用提示词
 * @param prompt 选中的提示词
 */
const handleSelect = (prompt) => {
  emits('setPrompt', {
    prompt: prompt.content,
    title: prompt.name,
    outputFormat: prompt.outputFormat,
    analyzeModel: prompt.analyzeModel
  })
}

onMounted(() => {
  getTheCustomPromptTemplateList()
})
</script>

<style lang="scss" scoped>
.common-used {
  // width: 800px;
  max-width: 800px;
  max-height: 400px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  padding: 12px 12px 0;
  background: #ffffff;
  box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.1);
  margin-bottom: 12px;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    height: 30px;

    .header__left {
      display: flex;
      align-items: center;

      &-text {
        font-size: 16px;
      }
    }

    .icon-ai-generate-2 {
      font-size: 20px;
      margin-right: 8px;
    }

    .icon-close-large-line {
      padding: 6px;
      background-color: transparent;
      border-radius: 8px;
      font-size: 18px;
      font-weight: 500;
      cursor: pointer;

      &:hover {
        background: #f2f3f5;
      }
    }
  }

  &__list {
    height: 362px;
    overflow-y: scroll;
  }
}
.colorful-text {
  background: linear-gradient(90deg, #1574ff, #5952ff, #a969fe);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px;
  gap: 4px;
  align-self: stretch;
  height: 66px;
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    background: #f2f3f5;
  }

  &__title {
    display: flex;
    align-items: center;

    img {
      margin-right: 8px;
    }
  }

  &__content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

/* 淡入淡出动画 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.4s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
